import React, {Fragment} from 'react';

import style from './driverETA.module.css';

import DriverETACarouselCamera from './DriverETACarouselCamera';
import SelectTimeCommon from '../../common/SelectTimeCommon';
import DockOverloadCommon from '../../common/DockOverloadCommon';

import Button from '@material-ui/core/Button';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import DotIcon from '@material-ui/icons/Lens';

const styles = (theme: Theme) =>

  createStyles({
    button: {
      textTransform: 'none',
      padding: '10px 25px',
      marginTop: '20px'
    },
    dotIconWrapper: {
      color: 'green'
    }
  });

interface DriverETASelectManuallyProps {
  classes: any; 
  handleChange: (event: any) => void;
  selectTime: string;
  selectedValue: number;
  handleChangeSelectedValue: (event: any) => void;
  setETA: () => void;
  activeStep: number;
  handleNext: () => void;
  handleBack: () => void;
  handleStepChange: (step: number) => void;
  dockLoad: Array<number>;
  workingHours: Array<{ end: string, start: string }>;
  cams: Array<{ url:string, description: string } | null>;
  ghaId: number;
}

const driverETASelectManually = (props: DriverETASelectManuallyProps) => {

  const { classes } = props;

  const work: any= {}
    props.workingHours.forEach(item => {
    const start: number = Number(item.start.substring(0,2));
    const end: number = Number(item.end.substring(0,2));
    for( let i=start; i<end; i+=1) {
      work[i]=props.dockLoad[i]
    }
  });

  return (
   <Fragment>
     <div className={ style.currentWhiteWrapper }>
       <span className={ style.currentWhite }>
        Current Wait Time:
       </span>
       <span className={ style.dotIconWrapper }><DotIcon fontSize='small' /></span>
     </div>
     <div>
      <p className={ style.ticker }>
        <span className={ style.title }> ++++++ Heavy dock activity expected at time slots marked in red below - drivers are requested to avoid showing up at those times +++++++ </span>
      </p>
     </div>
     <div className={ style.dockOverloadWrapper }>
       <DockOverloadCommon
        forInfo={ false }
        selectedValue={ props.selectedValue }
        handleChangeSelectedValue={ props.handleChangeSelectedValue }
        fontSizeIcon={ 40 }
        fontSizeLabel={ 16 }
        padding={ 2 }
        work={ work }
       />
     </div>
     <div className={ style.buttonETADiv }>
      <div >
        <span>ETA</span>
        <span className={ style.selectTime }>
         <SelectTimeCommon 
          handleChange={ props.handleChange }
          selectTime={ props.selectTime }
          work={ work }
         />
        </span>
      </div>
      <Button
        variant="contained"
        onClick={ props.setETA }
        color='primary'
        className={ classes.button } 
      >
        Set ETA (manually)
      </Button>
     </div>
     <DriverETACarouselCamera
        activeStep={ props.activeStep }
        handleNext={ props.handleNext }
        handleBack={ props.handleBack }
        handleStepChange={ props.handleStepChange }
        cams={ props.cams }
        ghaId={ props.ghaId }
     />
   </Fragment>
  )
};

export default withStyles(styles)(driverETASelectManually);